import { render, staticRenderFns } from "./pointPosition.vue?vue&type=template&id=2cdacf18&scoped=true&"
import script from "./pointPosition.vue?vue&type=script&lang=js&"
export * from "./pointPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdacf18",
  null
  
)

export default component.exports